import VideoPlayer from '@/components/VideoPlayer'

export default function VideoPreviewModal({video}) {
    return (
        <div className="flex w-full max-w-[1280px] aspect-video p-3">
            <VideoPlayer asset={video} autoPlay className='w-full h-full' />
        </div>
    )
}